import * as Rx from 'rxjs';
import * as React from 'react';

import ubisoftConnectService, { Constants as UbisoftConnectServiceConstants } from 'modules/ubisoft-connect-service';
import { ILoginProps, ILoginPopinState } from '../login.types';
import Spinner from 'components/spinner/spinner.component';
import './login.styles.less';

export default class LoginPopin extends React.Component<ILoginProps, ILoginPopinState> {
    private readonly loginIframeContainerRef: React.RefObject<HTMLDivElement>;
    private ubisoftConnectIFrame: HTMLIFrameElement;
    private subsription: Rx.Subscription;
    private initialIframeSize = {
        height: '660px',
        width: '100%'
    };

    constructor(props: ILoginProps) {
        super(props);
        this.loginIframeContainerRef = React.createRef<HTMLDivElement>();

        this.state = {
            isLoginIframeMounted: false
        };
    }

    /** Show "Login" window or only check current account status, even if user is logged in */
    public componentDidMount(): void {
        this.props.setUpLoginSessionCallback();
        this.subsription = ubisoftConnectService.sizeSubject.subscribe(this.onSizeChanged);

        if (this.props.alwaysConfirmAccount) {
            this.generateLoginIframe(this.props.activeLanguageCode);
        } else {
            /* In some rare cases, like in preview, session can be initialized even before this component is mounted.
               In this case we should attempt to render Connect window, since callback might never be called. */
            if (!this.props.fetching && !this.props.loginSession && !this.state.isLoginIframeMounted) {
                return this.generateLoginIframe(this.props.activeLanguageCode);
            }

            this.props.requestLoginSession();
        }
    }

    public componentWillUnmount() {
        this.subsription.unsubscribe();
    }

    public onSizeChanged = (height: number) => {
        if (this.state.isLoginIframeMounted) {
            this.ubisoftConnectIFrame.setAttribute('height', `${height}px`);
        }
    };

    private generateLoginIframe(activeLanguageCode?: string): void {
        this.loginIframeContainerRef.current!.innerHTML = '';
        this.ubisoftConnectIFrame = ubisoftConnectService.getLoginPopIn(
            UbisoftConnectServiceConstants.EXTERNAL_LOGIN_OPTIONS.UBISOFT,
            activeLanguageCode,
            this.initialIframeSize
        );
        this.loginIframeContainerRef.current!.appendChild(this.ubisoftConnectIFrame);
        this.setState({ isLoginIframeMounted: true });
    }

    public componentDidUpdate(prevProps: ILoginProps): void {
        if (!this.props.fetching && !this.props.loginSession) {
            if (!this.state.isLoginIframeMounted || this.props.activeLanguageCode !== prevProps.activeLanguageCode) {
                this.generateLoginIframe(this.props.activeLanguageCode);
            }
        }
    }

    public render(): JSX.Element {
        return (
            <div className="sitegen-login-page">
                {!this.state.isLoginIframeMounted && <Spinner />}
                <div
                    className="sitegen-login-page__ubisoft-connect-container"
                    ref={this.loginIframeContainerRef}
                />
            </div>
        );
    }
}
